<script setup lang="ts">
import { Icon } from '@iconify/vue'
defineProps<{ scopeOfWork: any }>()
</script>

<template>
  <table>
    <template v-for="svc in scopeOfWork" :key="svc.service.id">
      <tr class="service-row">
        <th><Icon :icon="svc.service.icon" :height="20" />&nbsp;{{ svc.service.description }}</th>
        <td><span style="color: var(--text-tertiary)">$</span> {{ svc.price }}</td>
      </tr>
      <tr class="included-row">
        <td colspan="2">
          <template v-if="svc.included_services?.length">
            <p class="included-title">Included services</p>
            <ul class="included-services">
              <li v-for="includedSvc in svc.included_services" :key="includedSvc.id">
                {{ includedSvc.description }}
              </li>
            </ul>
          </template>
          <p v-else class="no-services">No included services</p>
        </td>
      </tr>
    </template>
  </table>
</template>

<style scoped lang="scss">
th {
  display: flex;
  font-weight: normal;
  width: 256px;
}

td {
  width: 86px;
}

.included-row td {
  width: auto;
  padding: var(--spacing-spacing-xs) 0 var(--spacing-spacing-md) var(--spacing-spacing-md);
}

.included-title {
  margin-bottom: var(--spacing-spacing-3xs);
  font-size: var(--font-size-sm);
  font-weight: 500;
}

.included-services {
  list-style-type: disc;
  padding-left: var(--spacing-spacing-md);
  font-size: var(--font-size-sm);
}

.no-services {
  color: var(--text-tertiary);
  font-style: italic;
  font-size: var(--font-size-sm);
}
</style>
